import React from 'react';
import PropTypes from 'prop-types';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  Slide,
  useMediaQuery,
} from '@mui/material';

// actions
import TaskDetailPage from '../TaskDetail';
import theme from '../../utils/theme';

import { setGlobalModals } from '../../redux/app/actions';

export const transition = React.forwardRef((props, ref) => <Slide direction="up" {...props} ref={ref} />);

const TaskModalComponent = ({
  // open,
  handleClose,
  navigate,
}) => {
  const dispatch = useDispatch();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const selectedEvent = useSelector((state) => state.event.selectedEvent)

  return (
    // <Dialog
    //   open={open}
    //   onClose={handleClose}
    //   TransitionComponent={transition}
    //   fullScreen={fullScreen}
    //   PaperProps={{
    //     sx: {
    //       m: 0,
    //       mx: fullScreen
    //         ? 0
    //         : 2,
    //     },
    //   }}
    // >
    // </Dialog>
    <TaskDetailPage
      navigate={navigate}
      hidePageWrapper
      handleOpen={() => {
        dispatch(setGlobalModals(null, null, null, null, {}, () => { }));
        setTimeout(() => {
          navigate(`/tasks/${selectedEvent.id}`);
        }, 250)
      }}
      handleClose={handleClose}
      fullScreen={fullScreen}
    />
  );
};

TaskModalComponent.propTypes = {
  // open: PropTypes.bool,
  handleClose: PropTypes.func,
  navigate: PropTypes.func.isRequired,
};

TaskModalComponent.defaultProps = {
  // open: false,
  handleClose: () => { },
};

export default (TaskModalComponent);
